import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EncryptService {
  // Key to encrypt
  private readonly key: string = 'p$G2h*Xm!9ZkY8xRt@W5cQ1bJvL#h7FgXz4KkX@b3zQm9Ff';

  // Author: Raúl Medina.
  // Date: 27.01.2025.
  // Description: Encrypt data with key and return base64 encoded string
  encryptData(data: string): string {
    const keyLength = this.key.length;
    let encrypted = '';

    for (let i = 0; i < data.length; i++) {
      const charCode = data.charCodeAt(i);
      const keyCharCode = this.key.charCodeAt(i % keyLength);
      const mixedCode = (charCode + keyCharCode + i) % 256;
      encrypted += String.fromCharCode(mixedCode);
    }

    return btoa(encrypted);
  }

  // Author: Raúl Medina.
  // Date: 27.01.2025.
  // Description: Decrypt data with key and return original string
  decryptData(encryptedData: string): string {
    const keyLength = this.key.length;
    const decoded = atob(encryptedData);
    let decrypted = '';

    for (let i = 0; i < decoded.length; i++) {
      const charCode = decoded.charCodeAt(i);
      const keyCharCode = this.key.charCodeAt(i % keyLength);
      const originalCode = (charCode - keyCharCode - i + 256) % 256;
      decrypted += String.fromCharCode(originalCode);
    }

    return decrypted;
  }

  // Author: Raúl Medina.
  // Date: 27.01.2025.
  // Description: Save encrypted data to sessionStorage
  saveToSessionStorage(key: string, data: string): void {
    const encryptedData = this.encryptData(data);
    sessionStorage.setItem(key, encryptedData);
  }

  // Author: Raúl Medina.
  // Date: 27.01.2025.
  // Description: Get encrypted data from sessionStorage
  getFromSessionStorage(key: string): string | null {
    const encryptedData = sessionStorage.getItem(key);
    if (!encryptedData) {
      return null;
    }
    return this.decryptData(encryptedData);
  }

  extractAccountCdFromToken(token: string): string {
    try {
      const payload = token.split('.')[1];
      const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
      const decodedToken = JSON.parse(decoded);
  
      // Extrae el valor después de 'realms/' en el campo 'iss'
      const match = decodedToken.iss?.match(/realms\/([^/]+)/);
      return match ? match[1] : '';
    } catch (error) {
      console.error('Error al decodificar el token o extraer accountCd:', error);
      return '';
    }
  }
}